<template>
    <template v-if="hasChildren(menu)">
        <v-list-group :value="menu.menu_name">
            <template #activator>
                <v-list-item @click="toggleMenu(menu)">
                    <div class="menu-item">
                        <span class="menu-text font-weight-bold">{{ menu.menu_name }}</span>
                        <v-icon class="ml-auto">
                            {{ open?.includes(menu.menu_name) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                        </v-icon>
                    </div>
                </v-list-item>
            </template>
            <AdminNavbarMenuItem v-for="(child) in menu.children_menu_list" :menu="child"/>
        </v-list-group>
    </template>
    <template v-else>
        <v-list-item :to="menu.menu_url" link :class="route.fullPath.includes(menu.menu_url) ? 'active-item' : ''">
            <div class="menu-item">
                <span class="menu-text">{{ menu.menu_name }}</span>
            </div>
        </v-list-item>
    </template>
</template>

<script setup lang="ts">
const route = useRoute();
const open = defineModel<any[]>();
const props = defineProps<{
    menu: any,
}>()

const toggleMenu = (menu: any) => {
  if (open.value) {
    localStorage.setItem('click_url_admin', '0');
    if (open.value.includes(menu.menu_name)) {
        open.value = open.value.filter(item => item != menu.menu_name)
        localStorage.setItem('opening_menu_admin', open.value.filter(item => item != menu.menu_name).toString());
    } else {
        open.value?.push(menu.menu_name)
        localStorage.setItem('opening_menu_admin', open.value.toString());
    }
  }
}

const hasChildren = (item: any) => item.children_menu_list && item.children_menu_list.length > 0
</script>
<style scoped>
.custom-navbar {
  background-color: #f8f9fa;
}

.menu-item {
  display: flex;
  align-items: center;
}

.menu-icon {
  font-size: 18px;
  margin-right: 8px;
  color: #333;
}

.menu-text {
  font-size: 15px;
}

.custom-sub-item {
  padding-left: 50px;
  font-size: 14px;
  display: flex;
  align-items: center;
}
::v-deep(.v-list-item:hover) {
  background-color: #D2F4EA !important;
}
.active-item {
  background-color: #D2F4EA !important;
}
::v-deep(.v-list-item__append) {
  display: none !important;
}
</style>